/**
 * Hover label for icon-rail controls. Pure CSS (named group-hover) — appears as
 * a dark pill to the right of the wrapped control after a short delay. Replaces
 * native `title` tooltips for an instant, consistently styled hint.
 */
export function RailTooltip({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}): React.JSX.Element {
  return (
    <div className="group/tip relative flex items-center justify-center">
      {children}
      <span
        role="tooltip"
        className="pointer-events-none absolute left-full top-1/2 z-[1100] ml-3 -translate-y-1/2 whitespace-nowrap rounded-md border border-white/10 bg-[#222] px-2.5 py-1 text-[11px] font-medium text-foreground opacity-0 shadow-lg shadow-black/40 transition-opacity duration-150 delay-150 group-hover/tip:opacity-100"
      >
        {label}
      </span>
    </div>
  );
}
